module.exports = __webpack_public_path__ + "99497c1f2ce4e2ea56ab0f94450b0337.png";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/assets/images/Logo_Sidder.png
// module id = 41
// module chunks = 0